<div class="modal-body">
  <div class="container-fluid" style="width: 100%;height: 100%;">
    <div class="grid">
      <div id="header" class="form-group">
        <label
          for="header"
          style="color: #324169; font-weight: 600;font-size: 25px;"
          >We've received your request!</label
        >
      </div>
      <div id="info" class="form-group">
        <label
          for="info"
          style="color: #324169; font-weight: 400;font-size: 14px;"
          >You will receive an email from LineLeap within 24 hours accepting or
          denying your push notification request.</label
        >
      </div>
      <div id="submit">
        <div class="submit-button" (click)="modalRef.hide()">
          Okay
        </div>
      </div>
    </div>
  </div>
</div>
